export const CHANGE_CURRENT_AREA = "artist/CHANGE_CURRENT_AREA";
export const CHANGE_CURRENT_TYPE = "artist/CHANGE_CURRENT_TYPE";

export const CHANGE_ARTIST_LIST = "artist/CHANGE_ARTIST_LIST";
